import { useMutation } from "@apollo/client";
import { ACC_PUT_CACHE } from "components/gql/gql_queries_acc";
import { consoleBeauty, logGQLError } from "data/functions";

export function PutCacheMutation() {
  const queryName = "PutCache";
  const [mutation, variables] = useMutation(ACC_PUT_CACHE, {
    onCompleted: (data) => {
      if (data?.acc_putCache.code === 200) {
        // consoleBeauty("Успешное обновление токена", "GraphQL", "darkgreen");
      } else {
        logGQLError(queryName, data?.acc_putCache);
      }
    },
    onError: (e) => {
      logGQLError(queryName, e);
    },
  });
  return [mutation, variables];
}
